import { Component, Input, OnChanges } from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GrupyIds, Kursant} from "../../services/kursant";
import { KursanciService } from '../../services/kursanci.service'

@Component({
  selector: 'app-kursant-form',
  templateUrl: './kursant-form.component.html',
  styleUrls: ['./kursant-form.component.scss']
})
export class KursantFormComponent implements OnChanges {

    kursantForm: FormGroup;

    @Input() // kursant: Kursant;

    initialValue: any;
    // kursant: Kursant;

    constructor(
        private formBuilder: FormBuilder,
        // private kursanciService: KursanciService,
        ) {
        this.createForm();
    }

    createForm() {
        this.kursantForm = this.formBuilder.group({
            adres: [''],
            data_urodzenia: [''],
            e_mail: [''],
            haslo: [''],
            grupaId: this.formBuilder.array([]),
            imie: ['', Validators.required],
            imiona_rodzicow: [''],
            isActive: [true],            
            kod: [''],
            login: [''],
            miejsce_urodzenia: [''],
            miejscowosc: [''],
            nazwisko: ['', Validators.required],
            telefon_dom: [''],
            telefon_kom: [''],
            telefon_praca: [''],
            uwagi: [''],
        });
    }

    /*ngOnChanges(changes) {
        if (changes.initialValue) {
            this.kursantForm.reset(changes.initialValue.currentValue);
        }
        this.setGrupaId(this.initialValue.grupaId);
    }*/

    ngOnChanges(changes) {
        if (changes.initialValue) {
            this.kursantForm.patchValue(changes.initialValue.currentValue);
        }
        // this.setGrupaId(this.initialValue.grupaId);
    }

    get grupaId(): FormArray {
        return this.kursantForm.get('grupaId') as FormArray;
    };

    setGrupaId(grupaId: GrupyIds[]) {
        const grupyFGs = grupaId.map(grupyId => this.formBuilder.group(grupyId));
        const grupyIdFormArray = this.formBuilder.array(grupyFGs);
        this.kursantForm.setControl('grupaId', grupyIdFormArray);
    }

    zapiszDoGrupy() {
        this.grupaId.push(this.formBuilder.group(new GrupyIds()));
    }

    /* onSubmit() {
        this.kursant = this.prepareZapiszKursanta();
        this.kursanciService.dodajKursanta(this.kursant).subscribe();
        this.ngOnChanges(this.kursant);
    }

    prepareZapiszKursanta(): Kursant {
        const formModel = this.kursantForm.value;

        // deep copy of form model lairs
        const grupyDeepCopy: GrupyIds[] = formModel.grupaId.map(
            (grupaId: GrupyIds) => Object.assign({}, grupaId)
        );

        // return new `Hero` object containing a combination of original hero value(s)
        // and deep copies of changed form model values
        const zapiszK: Kursant = {
            $key: this.kursant.$key,
            adres: formModel.adres as string,
            data_urodzenia: formModel.data_urodzenia as string,
            e_mail: formModel.e_mail as string,
            haslo: formModel.haslo as string,
            grupaId: grupyDeepCopy,
            imie: formModel.imie as string,
            imiona_rodzicow: formModel.imiona_rodzicow as string,
            kod: formModel.kod as string,
            login: formModel.login as string,
            miejsce_urodzenia: formModel.miejsce_urodzenia as string,
            miejscowosc: formModel.miejscowosc as string,
            nazwisko: formModel.nazwisko as string,
            telefon_dom: formModel.telefon_dom as string,
            telefon_kom: formModel.telefon_kom as string,
            telefon_praca: formModel.telefon_praca as string,
            uwagi: formModel.uwagi as string,
        };
        return zapiszK;
    }*/

    isErrorVisible(field: string, error: string) {
        return this.kursantForm.controls[field].dirty
            && this.kursantForm.controls[field].errors
            && this.kursantForm.controls[field].errors[error];
    }

    get value() {
        return this.kursantForm.value;
    }

    get valid() {
        return this.kursantForm.valid;
    }

    reset() {
        this.kursantForm.reset();
    }

}



// WEBPACK FOOTER //
// ./src/app/kursanci/kursant-form/kursant-form.component.ts